import React, { createContext, useCallback, useContext, useMemo, useReducer, useState } from 'react';
import type { DemoAction, DemoState, DialogId, WorldState } from '../types/demo';
import { createInitialState, demoReducer, getInitialAccess } from '../utils/demoReducer';
import { getWorldState } from '../utils/worldState';
interface DemoContextValue {
  state: DemoState;
  dispatch: React.Dispatch<DemoAction>;
  world: WorldState;
  dialog: DialogId | null;
  openDialog: (id: DialogId) => void;
  closeDialog: () => void;
  announcement: string;
  announce: (message: string) => void;
}
const DemoContext = createContext<DemoContextValue | undefined>(undefined);
export function DemoProvider({
  children
}: {
  children: React.ReactNode;
}) {
  const [state, dispatch] = useReducer(demoReducer, undefined, () => createInitialState(getInitialAccess()));
  const [dialog, setDialog] = useState<DialogId | null>(null);
  const [announcement, setAnnouncement] = useState('');
  const announce = useCallback((message: string) => {
    setAnnouncement('');
    window.setTimeout(() => setAnnouncement(message), 40);
  }, []);
  const world = useMemo(() => getWorldState(state.actionEffects, state.witnessEffects), [state.actionEffects, state.witnessEffects]);
  const value = useMemo<DemoContextValue>(() => ({
    state,
    dispatch,
    world,
    dialog,
    openDialog: setDialog,
    closeDialog: () => setDialog(null),
    announcement,
    announce
  }), [state, world, dialog, announcement, announce]);
  return <DemoContext.Provider value={value} data-id="element-560" data-mp="26nywj2tzzgmo">{children}</DemoContext.Provider>;
}
export function useDemo() {
  const context = useContext(DemoContext);
  if (!context) throw new Error('useDemo must be used inside DemoProvider');
  return context;
}